import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Observable, from } from 'rxjs';
import { retry, catchError, tap } from 'rxjs/operators';
import { Router, ActivatedRoute } from '@angular/router';
import { ModalController, NavController } from '@ionic/angular';
import { ToasterService } from '../helpers/toaster.service';
import { StorageServiceAAA } from '../helpers/aaa-storage.service';
import { SessionExpiredComponent } from '../components/session-expired/session-expired.component';
import { CommonService } from '../helpers/common.service';
import { Capacitor } from '@capacitor/core';
import { environment } from '../../environments/environment';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
	errorStatus: number = 0;
	constructor(private storage: StorageServiceAAA, private toast: ToasterService, private router: Router, 
		public modalController: ModalController,
		 private navCtrl: NavController, private commonService:CommonService) { }

	intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		// Native builds run on a local web server (capacitor://localhost), so relative
		// /api calls resolve to app index.html unless we point them to the hosted API proxy.
		if (Capacitor.isNativePlatform() && req.url.startsWith('/api/secure/')) {
			const apiProxyBaseUrl = (environment.apiProxyBaseUrl || '').replace(/\/$/, '');
			if (apiProxyBaseUrl) {
				req = req.clone({ url: `${apiProxyBaseUrl}${req.url}` });
			}
		}

		const headers: any = {};
		headers['Cache-Control'] = 'no-cache';
		//headers['Pragma'] = 'no-cache';
		//headers['language_code'] = 'en';
		headers['Content-Type'] = 'application/json';
		//headers['clientID'] = this.commonService.get('userID') ? this.commonService.get('userID') : 'NA';

		if(req.headers.get('DeleteContentType') == 'Yes') delete headers['Content-Type'];

		// 'DeleteContentType' is a client-only signal; strip it so it isn't sent
		// over the wire, where it would fail CORS preflight (not in allowedHeaders).
		req = req.clone({
			headers: req.headers.delete('DeleteContentType'),
			setHeaders: headers,
			// withCredentials: true
		});

		// Handle the request
		return next.handle(req).pipe(tap((event: HttpEvent<any>) => {
			if (event instanceof HttpResponse) {
				//console.log(event);

			}
		},
		(err: any) => {
			// console.log(err);
			if (err.status === 401) {
				this.errorStatus += 1;
				// console.log(this.errorStatus);
				if (this.errorStatus === 1) {
					this.storage.get('userType').then(user => {
					// Reset DashTabSelect before clearing storage on session expiry
					this.commonService.remove('DashTabSelect');
						this.storage.clear();
						this.commonService.clear();
						this.toast.displayToast('Session has Expired Please Login Again');
						this.navCtrl.navigateRoot(['/login']);
						//this.router.navigate[('/login')]
						// this.loading = false;
					})
				}
			}
		}));
	}

	async sessionExpired(user: any) {
		this.modalController.dismiss();
		const modal = await this.modalController.create({
			component: SessionExpiredComponent,
			backdropDismiss: false,
			cssClass: 'forgot-password-popup-mobile session-expired',
			componentProps: {
				userType: user
			}
		});
		// this.storage.clear();
		/* modal.onDidDismiss().then((data) => {
			if (data['data']) {
				console.log(data['data']);

			}
		}) */

		return await modal.present();
	}

}

